import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,

} from '../actions/types';

const initialState = {
  users: [],
  userProfile: null,
  loading: false,
  error: null,
  registrationError: null,
  newUser: null,
  page: 1,
  hasMore: true,
  total: 0,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS: {
      const { results, page, pages, total } = action.payload.data;

      return {
        ...state,
        loading: false,
        users: results || [],
        page: page || 1,
        hasMore: page < pages,
        total: total || 0,
      };
    }

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userProfile: action.payload,
      };

    case FETCH_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    case USER_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        registrationError: null,
      };

    case USER_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        newUser: action.payload,
      };

    case USER_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        registrationError: action.payload,
      };

    case UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,

        users: state.users.map((user) =>
          user.user_id === action.payload.user_id
            ? action.payload
            : user
        ),

        userProfile:
          state.userProfile?.user_id === action.payload.user_id
            ? action.payload
            : state.userProfile,
      };

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;